import { useEffect, useRef, useState } from 'react'
import { TextField, Button, Typography, Stack, Grid, Autocomplete, IconButton } from '@mui/material'
import { AddCircleRounded } from '@mui/icons-material'
import { apiGet, apiPut } from '../Api_Functions'
import SmartDatePicker from '../smartDatePicker/Index'
import { SmartDialog } from '../utilities/SmartDialog'
import { useSmartTranslation } from '../hooks/useSmartTranslation'
import AlertUI from '../AlertUI'

const AddElementFeature = (props) => {
  const { endpoint, parameter, title, referenceName, disable, onAlert, partId, feature } = props
  const [showDialog, setShowDialog] = useState(false)
  const [unitTypes, setUnitTypes] = useState([])
  const quantity = useRef(1)
  const entryDate = useRef(new Date())
  const value = useRef(1)
  const unit = useRef(feature?.unit ? feature.unit.id : null)
  const { t_ } = useSmartTranslation()
  const [AlertElementDialog, showAlertDialog] = AlertUI()
  const updateQuantity = () => {
    if (!endpoint) return

    if (quantity.current <= 0) {
      showAlertDialog({
        title: t_(''),
        message: t_('Quantity must be greater than 0'),
        severity: 'error'
      })
      return
    }

    if (isNaN(entryDate.current)) {
      showAlertDialog({
        title: t_(''),
        message: t_('Entry date is invalid'),
        severity: 'error'
      })
      return
    }
    if (feature.value === null) {
      showAlertDialog({
        title: t_(''),
        message: t_('Nominal feature must have a value'),
        severity: 'error'
      })
      return
    }
    if (feature.lowerTolerance === null) {
      showAlertDialog({
        title: t_(''),
        message: t_('Lower tolerance feature must have a value'),
        severity: 'error'
      })
      return
    }
    if (feature.upperTolerance === null) {
      showAlertDialog({
        title: t_(''),
        message: t_('Upper tolerance feature must have a value'),
        severity: 'error'
      })
      return
    }
    if (feature.unit === null) {
      showAlertDialog({
        title: t_(''),
        message: t_('Unit feature must have a value'),
        severity: 'error'
      })
      return
    }
    setShowDialog(false)

    apiPut(endpoint + '/' + partId + '/' + parameter + '/' + Date.parse(entryDate.current) + '/' + value.current + '/' + unit.current)
      .catch(err => {
        onAlert({
          title: 'Error updating quantity',
          severity: 'error',
          message: 'Quantity could not be updated: ' + err
        })
      })
    quantity.current = 1
  }
  function onClickFunction () {
    entryDate.current = new Date()
    setShowDialog(true)
  }

  useEffect(() => {
    const loadUnitTypes = async () => {
      const response = await apiGet('units')
      setUnitTypes(response)
    }
    loadUnitTypes()
  }, [unitTypes])
  const renderInput = (params, label, error) => {
    return (
      <TextField
        {...params}
        label={label}
        error={error}
      />
    )
  }

  return (
    <div>
      <SmartDialog
        setOpen={showDialog}
        acceptCallback={updateQuantity}
        cancelCallback={() => setShowDialog(false)}
        title={{
          icon: <AddCircleRounded color='primary' sx={{ fontSize: '1.5em' }} />,
          render:
  <Stack
    direction='row'
    justifyContent='center'
    alignItems='center'
  >
    <Typography variant='h6' color='primary'> {referenceName}</Typography>
  </Stack>
        }}
        renderComponent={
          <>
            {AlertElementDialog}
            <Grid container spacing={3} justifyContent='center' sx={{ padding: (theme) => theme.spacing(2) }}>
              <Grid item xs={4}>
                <TextField
                  // error={value.current <= 0}
                  label={t_('Value')} defaultValue={1} type='number' onChange={(eventValue) => { value.current = eventValue.target.value }}
                />
              </Grid>
              <Grid item xs={4}>
                <Autocomplete
                  disableClearable
                  forcePopupIcon={false}
                  defaultValue={feature?.unit}
                  options={unitTypes}
                  getOptionLabel={(option) => option.code}
                  isOptionEqualToValue={(option1, option2) => option1.id === option2.id}
                  onChange={(event, value) => {
                    unit.current = value.id
                  }}
                  renderInput={(params) => renderInput(params, t_('Unit'), false)}
                />
              </Grid>
              <Grid item xs={4}>
                <SmartDatePicker resultDate={entryDate} />
              </Grid>
            </Grid>
          </>
        }
      />
      {title === undefined
        ? (
          <IconButton
            color='primary'
            onClick={onClickFunction}
            disabled={disable}
          >
            <AddCircleRounded />
          </IconButton>)
        : (
          <Button
            color='primary'
            onClick={onClickFunction}
            disabled={disable}
          >
            <AddCircleRounded style={{ fontSize: '1.2em' }} />
            <Typography style={{ marginLeft: '0.4em', fontSize: '0.875rem' }}>{title}</Typography>
          </Button>)}
    </div>
  )
}

export default AddElementFeature
